import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { SharedModule } from "app/shared/shared.module";
//import { ZXingScannerModule } from '@zxing/ngx-scanner';
import { SelectAutocompleteComponent } from "../../shared/modules/select-autocomplete/select-autocomplete.component";

@NgModule({
  imports: [
    CommonModule,
    SharedModule,
    SelectAutocompleteComponent,
    //ZXingScannerModule
  ],
  exports: [
    //LiveScannerComponent,
  ],
})
export class ScannerModule {}
